module.exports = __webpack_public_path__ + "img/banner3a.fdf4df21.jpg";